import React from "react";
import { Col, Form, Input, Modal, Row, Select, Radio, theme, Spin } from "antd";
import { SUCCESS_COLOR } from "../../constants/color";
import { PATCH, POST } from "../../frameworks/HttpClient";
import { URL_CHEMICAL } from "../../constants/urls";
import useDropdownItem from "../../common/useDropdownItem";
import ErrorMessages from "../../common/ErrorMessages";
import _ from "lodash";

export default function AddQualityChemicalTankModal(props) {

  const { open, onClose, target, onUpdate} = props;
  const [loading, setLoading] = React.useState(false);
  const [ errorMessages, setErrorMessages ] = React.useState(null);
  const [form] = Form.useForm();
  const isCreate = target === 'add'
  const [debouncedChemicalQuality, setDebouncedChemicalQuality] = React.useState('');
  const debounceChemicalQuality = React.useCallback(_.debounce((_searchVal) => { setDebouncedChemicalQuality(_searchVal) }, 800), []);

  const QualityChemicalDropdown = useDropdownItem({manual: true, url: URL_CHEMICAL.QUALITY_CHEMICAL, label: 'name', value:'id', pagination: true, params: { page_size: 999, name : debouncedChemicalQuality} })

  const {
    token: { colorWarning },
  } = theme.useToken();

  const handleOk = async() => {
    setLoading(true)
    setErrorMessages(null)
    try {
      const data = await form.validateFields()
      data['meter'] = data.meter ? data.meter : null;
      if(isCreate){
        await POST(URL_CHEMICAL.QUALITY_CHEMICAL_TANK, data)
      } else {
        await PATCH(`${URL_CHEMICAL.QUALITY_CHEMICAL_TANK}${target.id}/`, data)
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    if(open){
      setErrorMessages(null)
      QualityChemicalDropdown.fetchOptions();
      if(isCreate){
        form.resetFields();
      } else {
        form.setFieldsValue({...target, 
        })
      }
    }
  },[open])

  React.useEffect(() => {
    if(open)
      QualityChemicalDropdown.fetchOptions({});
  },[debouncedChemicalQuality])

	return(
    <Modal
      open={open}
      onCancel={onClose}
      okText={isCreate ? "ตกลง" : "แก้ไข"}
      okButtonProps={{ style: { backgroundColor : isCreate ? SUCCESS_COLOR : colorWarning}, loading: loading }}
      cancelText={"ไม่"}
      cancelButtonProps={{ loading: loading }}
      title={isCreate ? "เพิ่มแทงก์เก็บสารเคมีคุณภาพ" : "แก้ไขแทงก์เก็บสารเคมีคุณภาพ"}
      width={500}
      onOk={handleOk}
    >
      <ErrorMessages message={errorMessages}/>
      <Form
        form={form}
        layout={'vertical'}
      >
        <Row>
          <Col span={24}>
            <Form.Item 
              label={'ชื่อแทงก์เก็บสารเคมีคุณภาพ'} 
              style={{marginRight : 10}}
              name={"name"}
              rules={[
                {
                  required: true,
                  message: 'กรุณากรอกข้อมูล'
                },
              ]}
            >
              <Input style={{ width : '100%' }} placeholder={'ชื่อแทงก์เก็บสารเคมีคุณภาพ'} autoComplete="off"/>
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item 
              label={'ชื่อสารเคมี'} 
              style={{marginRight : 10}}
              name={"chemical"}
              rules={[
                {
                  required: true,
                  message: 'กรุณากรอกข้อมูล'
                }
              ]}
            >
              <Select 
                showSearch
                style={{ width : '100%' }} 
                placeholder={'ชื่อสารเคมี'} 
                options={QualityChemicalDropdown.options}
                filterOption={false}
                notFoundContent={QualityChemicalDropdown.loading ? <Spin size="small" /> : "-"}
                onSearch={debounceChemicalQuality}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item 
              label={'ประเภท'} 
              style={{marginRight : 10}}
              name={"has_meter"}
              rules={[
                {
                  required: true,
                  message: 'กรุณาเลือกประเภทแทงก์'
                },
              ]}
            >
              <Radio.Group>
                <Radio value={false}>แทงก์</Radio>
                <Radio value={true}>มิเตอร์</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item 
              label={'รายละเอียด'} 
              style={{marginRight : 10}}
              name={"note"}
            >
              <Input.TextArea style={{ width : '100%' }} placeholder={'รายละเอียด'} autoComplete="off"/>
            </Form.Item>
          </Col>

        </Row>
      </Form>
    </Modal>
)
}